import React from 'react';

export function ShoppingIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M5 7V5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v2"
      />
      <path
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M3 7h14l-1 10H4z"
      />
    </svg>
  );
}
